import { useEffect, useRef, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetPagesSectionData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { pageSectionColumns } from "../../lib/definitions";
import { deletePagesSectionForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import i18n from "../../lib/i18n";

export default function PagesSection() {

    const [pagesData, setPagesData] = useState([]);
    const deleteRef = useRef(null);
    const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [loadingDelete, setLoadingDelete] = useState(false);  
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            deleteRef.current && 
            !deleteRef.current.contains(event.target)
            ) {
            closeDeleteConfirmation();
            }
        };

        if (deleteConfirmation.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [deleteConfirmation.isOpen]);


    const handleApi = async () => {
        setIsLoading(true);  
        const pageData = await GetPagesSectionData();
        setPagesData([]);
        pageData.map((e) => setPagesData((prev) => [...prev, e]));
        setIsLoading(false);  
    };

    const openDeleteConfirmation = (id) => {
        setDeleteConfirmation({ isOpen: true, idToDelete: id });
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmation({ isOpen: false, idToDelete: null });
    };

    const handelDelete = async () => {
        if (deleteConfirmation.idToDelete) {
            setLoadingDelete(true);
            const result = await deletePagesSectionForm(deleteConfirmation.idToDelete);
            if (result) {
                setLoadingDelete(false);
                handleApi();
            }
            closeDeleteConfirmation();
        }
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
            <div className="flex flex-col sm:flex-row sm:items-baseline bg-thirdly  justify-between px-5 py-5  gap-4">
                <h1 className="text-white text-lg ">{t("nav.page_sections")}</h1>
                <Button background="#D36300" borderRadius="8px" color="white" padding="8px 20px" text={t("add_page_title.pageSection")} nav={"/pageSections/add"}  />
            </div>
            <div>
                {isLoading ? <TableSkeleton cols={pageSectionColumns}/> : (  
                    <Table columns={pageSectionColumns} rows={pagesData} openDeleteConfirmation={openDeleteConfirmation} edit="/pageSections/edit" />
                )}  
            </div>
            {deleteConfirmation.isOpen && <DeleteRecord ref={deleteRef} loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}
        </div>
    );
};